import { call, put, select, takeEvery } from 'typed-redux-saga';
import { dashboardActionCreators, FetchSalesDashboard, ISalesDashboardApiResponse } from '..';
import { IState } from '../..';
import { FilterTypes, getFilteredSalesDistricts, getFilters } from '../../filters';
import { uiActionCreators } from '../../ui';
import { DashboardActionKeys } from '../dashboardActionKeys';
import * as api from '../dashboardApi';

function* fetchSalesDashboard(action: FetchSalesDashboard) {
  yield put(uiActionCreators.toggleLoading('salesDashboard'));
  const filters = yield select((state: IState) => getFilters(state, FilterTypes.salesDashboard));

  const sds: string[] = yield select((state: IState) => getFilteredSalesDistricts(state, filters));

  const response: ISalesDashboardApiResponse = yield call(api.fetchSalesDashboard, { ...filters, salesDistricts: sds });

  if (response) {
    yield put(dashboardActionCreators.setSalesDashboard(response));
  }
  yield put(uiActionCreators.toggleLoading('salesDashboard'));
}

export function* watchFetchOpenOrders() {
  yield takeEvery(DashboardActionKeys.FETCH_SALES_DASHBOARD, fetchSalesDashboard);
}
